<template>
  <div class="completed" v-if="completed">
    <p>Thank you for your submission!</p>
  </div>
  <form class="apply-form" v-on:submit.prevent="submitForm" v-else ref="form">
    <div class="form-row split">
      <div>
        <label>* First name</label>
        <input type="text" required v-model="form.firstName" name="firstName" />
      </div>
      <div>
        <label>* Last name</label>
        <input type="text" required v-model="form.lastName" name="lastName" />
      </div>
    </div>
    <div class="form-row split">
      <div>
        <label>* Email</label>
        <input type="email" required v-model="form.email" name="email" />
      </div>
      <div>
        <label>* How did you hear about this position?</label>
        <div class="combo-dd">
          <div class="select">
            <select v-model="form.referrer" required name="referrer">
              <option v-for="item in jobSocial">{{ item.title }}</option>
              <!-- <option>LinkedIn</option>
              <option>Instagram</option>
              <option>Facebook</option>
              <option>IES Website</option>
              <option>Someone at IES</option>
              <option>Infostud</option>
              <option>Jobberty</option>
              <option>Loop</option>
              <option>SGA</option>
              <option>VFX Serbia</option>
              <option>Media (TV, radio, portal, newspaper...)</option>
              <option>From a Friend</option>
              <option>Other</option> -->
            </select>
          </div>
          <input
            v-if="form.referrer === 'Other'"
            type="text"
            v-model="form.referrerOther" name="referrerOther"
          />
        </div>
      </div>
    </div>
    <div class="form-row multi">
      <div>
        <div class="file">
          <span>* Attach CV</span><input type="file" required ref="fileCv" name="fileCv" />
        </div>
      </div>
      <div>
        <div class="file">
          <span>Attach Cover letter</span><input type="file" ref="fileCover" name="fileCover" />
        </div>
      </div>
    </div>
    <div class="form-row dynamic">
      <div>
        <div v-for="(item, index) in form.portfolio">
          <label>Portfolio URL</label>
          <input type="text" v-model="form.portfolio[index]" name="portfolio[]" />
        </div>
        <a class="add" @click="addPortfolio"></a>
      </div>
    </div>
    <div class="form-row fullw">
      <div>
        <label>* Why do you want to work at ILBE Studios?</label>
        <textarea v-model="form.why" required name="why"></textarea>
      </div>
    </div>
    <div class="form-row split">
      <div>
        <label
          >* Have you worked in animation/gaming industry/ projects before?</label
        >
        <div class="check radio" v-for="exp in experience">
          <label
            ><input
              type="radio"
              name="experience"
              required
              v-model="form.experience"
              :value="exp"
            /><em></em>{{ exp }}</label
          >
        </div>
      </div>
      <div>
        <label
          >* As we have offices in two cities, choose the one that most fits
          you</label
        >
        <div class="check radio">
          <label
            ><input
              type="radio"
              required
              name="location"
              v-model="form.location"
              value="Belgrade"
            /><em></em>Belgrade</label
          >
        </div>
        <div class="check radio">
          <label
            ><input
              type="radio"
              required
              name="location"
              v-model="form.location"
              value="Novi Sad"
            /><em></em>Novi Sad</label
          >
        </div>
        <div class="check radio">
          <label
            ><input
              type="radio"
              required
              name="location"
              v-model="form.location"
              value="Any"
            /><em></em>Any</label
          >
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="check">
        <label>
          <input type="checkbox" required v-model="form.agree" /><em></em>
          <span
            >By pressiing "apply for position" you acknowledge our
            <a href="/candidate-privacy-policy" target="_blank">candidate privacy policy</a></span
          >
        </label>
      </div>
    </div>
    <div class="form-row">
      <button class="box-btn submit-btn" xxv-on:click.prevent="submitForm">
        <span class="front-face elastic-btn"> Send my Application </span>
        <span class="side-face elastic-btn"> Send my Application </span>
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    jobSocial: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    form: {
      firstName: '',
      lastName: '',
      email: '',
      referrer: 'LinkedIn',
      referrerOther: '',
      portfolio: [''],
      why: '',
      experience: '',
      location: '',
      agree: false,
    },
    completed: false,
    experience: [
      'Yes, less then 1 year',
      'Yes, 1-3 years',
      'Yes, 3-5 years',
      'Yes, 5+ years',
      'No',
    ],
  }),
  methods: {
    submitForm() {
      var formData=new FormData(this.$refs.form);
      formData.append("apply", 1);
      var request=new XMLHttpRequest();
      request.open("POST", location.href);
      request.send(formData);
      this.completed=true;
    },
    addPortfolio() {
      this.form.portfolio = [...this.form.portfolio, ''];
    },
  },
};
</script>
